import { useCallback, useMemo } from "react";
import { ActionTableState } from "../../action-table/action-table";
import { useGetEmployeeClosureQueriesQuery as getEmployeeClosuresQuery } from "../../../../api/plamo-api";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const formatHours = (workTimesSum: number) => {
  return ("00" + (workTimesSum).toFixed(2).replace('.', ',')).substr(workTimesSum > 100 ? -6 : -5);
}

function EmployeeClosureList({ employeeId }) {
    const navigate = useNavigate();
    
    const columns = useMemo(() => [
      {
        title: "Id",
        dataIndex: "id",
        sorter: true,
        filter: true,
        type: 'int',
      },
      {
        title: "Beginn",
        dataIndex: "begin",
        render: v => dayjs(v).format('DD.MM.YYYY')
      },
      {
        title: "Ende",
        dataIndex: "end",
        render: v => dayjs(v).subtract(1, 'day').format('DD.MM.YYYY')
      },
      {
        title: "Stunden",
        dataIndex: "hoursSum",
        render: v => v ? formatHours(v) : ''
      },
    ], [])
  
    /*
    const assignmentLinkQueryString = useMemo(() => {
      const resultMap = {
        preselectedEmployeeId,
        preselectedCustomerId,
      }
      const result = Object.entries(resultMap).filter(([_1, value]) => value).map(([key, value]) => `${key}=${value}`).join('&');
      return result ? `?${result}` : ''
    }, [])
    */
  
    const applyPreselectedToFilter = useCallback(f => {
      const obj = JSON.parse(f);
      obj["employee.id"] = {
        c: "EQ",
        v: employeeId
      }
      return JSON.stringify(obj);
    }, [employeeId])
  
    return (
      <>
      <div>
      <ActionTableState
            isParentLoading={false}
            buttonRow={{
              buttons: [
                {
                  text: 'Erstellen',
                  buttonType: 'primary',
                  onClick: () => navigate(`/employee/${employeeId}/settlement/closure/new`)
                },
              ]
            }}
            tableData={{
              defaultSortKey: 'id',
              defaultSortDirection: 'desc',
              columns,
              dataSource: {
                pageableQueryEndpoint: ({ f, ...rest }) => getEmployeeClosuresQuery({ f: applyPreselectedToFilter(f), ...rest }),
                queryResultMapping: (result) => result?.items
              },
              actions: [
                {
                  caption: 'Details',
                  onClick: (item) => navigate(`/employee/${employeeId}/settlement/closure/${item.id}`)
                },
              ]
            }}            
          />
      </div>
      </>
    )
}

export default EmployeeClosureList;